'use client';
import { jsx } from 'react/jsx-runtime';

const TabItem = ({ children, className }) => /* @__PURE__ */ jsx("div", { className, children });
TabItem.displayName = "Tabs.Item";

export { TabItem };
//# sourceMappingURL=TabItem.mjs.map
